<!--
  App.vue - 应用根组件

  仅负责承载顶层路由出口，不直接处理业务逻辑。
-->
<template>
  <el-config-provider :z-index="3000" :message="{ max: 3 }">
    <RouterView />
    <PaymentReturnHandler />
  </el-config-provider>
</template>

<script setup lang="ts">
import { RouterView } from 'vue-router'
import { ElConfigProvider } from 'element-plus'
import PaymentReturnHandler from '@/components/payment/PaymentReturnHandler.vue'
</script>
